// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"372":"merch","795":"confidentiality"}[chunkId] + "." + {"372":"975a2a69","795":"401e87de"}[chunkId] + ".css";
};